
import LayoutContent from '../../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import PlayGame from './playgame';
import SpecialsScreen from '../specials';
function Index({dishs, setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [showDetailProduct, setShowDetailProduct] = useState(false);
      const [showPlaygame, setShowPlay] = useState(false);
  
 const [showSpecials, setShowSpecials] = useState(false);

  const games = [
    {
      id: 1,
      image: require('./assets/toe.png'),
      name: 'Juego Uno',
      screen: 'PlayGame',
    },
    {
      id: 2,
      image: require('./assets/2.png'),
      name: 'Juego Dos',
      screen: 'PlayGame',
    },
    {
      id: 3,
      image: require('./assets/3.png'),
      name: 'Juego Tres',
      screen: 'PlayGame',
    },
    {
      id: 4,
      image: require('./assets/4.png'),
      name: 'Juego Cuatro',
      screen: 'PlayGame',
    },
    {
      id: 5,
      image: require('./assets/5.png'),
      name: 'Juego Cinco',
      screen: 'PlayGame',
    },
    {
      id: 6,
      image: require('./assets/6.png'),
      name: 'Juego Seis',
      screen: 'PlayGame',
    },
  ];



  const GameCard = ({imageSource, gameName}) => (
    <div

      onClick={()=>setShowPlay(true)}
      style={{
        paddingHorizontal: 20,
        marginBottom: 40,
        paddingVertical: 15,
        width: 200,
        height: 280,
        borderRadius: 15,
        backgroundColor: 'white',
        shadowColor: '#000',
        shadowOffset: {width: 0, height: 2},
        shadowOpacity: 0.23,
        shadowRadius: 2.62,
        elevation: 4,
      }}>
      <img
        src={imageSource}
        style={{
          width: '100%',
          height: 200,
          objectFit: 'cover',
          alignSelf: 'center',
          borderRadius: 15,
        }}
      />
      <div style={{marginTop: 10, display: 'flex',flexDirection: 'row', alignItems: 'center'}}>
        <p style={{flex: 1, textAlign: 'left', marginLeft: 10}}>{gameName}</p>
        <img
          src={require('./assets/play.png')}
          style={{width: 30, height: 30, marginRight: 20}}
        />
      </div>
    </div>
  );


    
    
    return (
        <div style={{position: 'absolute', top: 4, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent setShowSpecials={setShowSpecials}  showBack={true} setShowListProduct={setShowListProduct} goHome={setShowHappy}>
                <div  style={{padding: '0 20px', background: "#DFDFDF", borderRadius: 30}}>
                    <div>
                        <img
                            src={require('./assets/game.png')}
                            style={{
                                marginTop: 10,
                                width: '100%',
                                height: 300,
                                objectFit: 'contain',
                                borderRadius: 20,
                            }}
                        />
            </div>
            
              <div
              style={{
                  display: 'flex',
                paddingInline: 30,
                  boxSizing: 'border-box',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                width: '100%',
                height: 470,
                overflow: 'scroll'
                }}>
                {games.map(game => (
                  <GameCard
                    key={game.id}
                    imageSource={game.image}
                    gameName={game.name}
                  />
                ))}
              </div>


                </div>
                {showPlaygame && <PlayGame
                    dishMenu={false}
                    setShowListProduct={setShowPlay}
                    setShowDetailProduct={false}
          />}
          
           {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
            </LayoutContent>
        </div>
    );
}
export default Index;